<template>
  <div>
    <v-card color="white lighten-1" class="mb-2 pa-3">
      <v-card-title class="d-flex justify-center align-center">
        <v-tabs v-model="tab">
          <v-tab v-for="idx in 5" :key="idx" v-if="idx <= shipping_count">
            Endereço {{ idx }}
          </v-tab>
        </v-tabs>
        <div>
          <v-btn icon v-if="shipping_count > 1">
            <v-icon large @click="changeShippingCount()" color="error">mdi-minus</v-icon>
          </v-btn>
          <v-btn icon v-if="shipping_count < 4">
            <v-icon large @click="changeShippingCount(true)" color="light-blue">mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="idx in shipping_count" :key="idx">
            <v-checkbox v-if="idx == 1" label="Mesmo endereço" v-model="same_address"></v-checkbox>
            <AddressForm ref="form" :address="client.shippingAddress[address_map[idx]]"></AddressForm>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-btn text @click="emitChangeStepper(false)">
      <v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon>
    </v-btn>
    <v-btn text @click="emitChangeStepper(true)">
      <v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon>
    </v-btn>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js";
import getters from "@/_backoffice/_registrations/mixins/getters.js"

export default {
  name: 'ClientShippingAddressStepper',
  mixins: [validations, getters],
  props: {
    client: {
      type: Object,
      default: () => { return {} }
    }
  },
  components:{
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
  },
  data() {
    return {
      same_address: false,
      shipping_count: 1,
      tab: 0,
    }
  },
  computed: {
    address_map() {
      return {
        1: 'primary',
        2: 'secondary',
        3: 'third',
        4: 'fourth',
        5: 'fifth',
      };
    },
  },
  methods: {
    validate(){
      let is_valid = true 
      for(let idx = 0; idx < this.shipping_count; idx++){
        is_valid = is_valid && this.$refs.form[idx].validate()
      }
      return is_valid
    },
    emitChangeStepper(increment) {
      if (increment) {
        this.prepareShipAddresses();
      }
      this.$emit("changeStepper", increment);
    },
    prepareShipAddresses() {
      this.client.shipping_addresses_attributes = [];
      for (let count = 1; count <= this.shipping_count; count++) {
        const address = this.client.shippingAddress[this.address_map[count]];
        if (address.cep !== '') {
          this.client.shipping_addresses_attributes.push(address);
        }
      }
    },
    changeShippingCount(increment) {
      if (increment) {
        this.shipping_count = Math.min(this.shipping_count + 1, 4);
      } else {
        if (this.shipping_count >= 2 && this.shipping_count <= 4) {
          this.resetShippingAddress(this.client.shippingAddress[this.address_map[this.shipping_count]]);
        }
        this.shipping_count = Math.max(this.shipping_count - 1, 1);
      }
    },
    resetShippingAddress(address) {
      address.zip = '';
      address.addr = '';
      address.neighborhood = '';
      address.complement = '';
      address.number = '';
      address.city = '';
      address.state = '';
    },
  },
  watch: {
    same_address(nv, ov) {
      if (nv) {
        this.client.shippingAddress.primary.zip = this.client.addresses_attributes.zip;
        this.client.shippingAddress.primary.addr = this.client.addresses_attributes.addr;
        this.client.shippingAddress.primary.complement = this.client.addresses_attributes.complement;
        this.client.shippingAddress.primary.neighborhood = this.client.addresses_attributes.neighborhood;
        this.client.shippingAddress.primary.city = this.client.addresses_attributes.city;
        this.client.shippingAddress.primary.state = this.client.addresses_attributes.state;
        this.client.shippingAddress.primary.number = this.client.addresses_attributes.number;
      }
    },
  },
};
</script>
